export default __webpack_public_path__ + "static/media/boost-icon.8254489d.svg";